<template>
  <div class="bg-secondary-13 pl-4 pb-2 pr-4 pt-0 rounded">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-3 mt-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.practitionerType"
            :clearable="false"
            :custom-error-msg="validationMessages.practitionerType"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo:"
            :options="practitionerTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-5 mt-4 mt-md-2 mt-sm-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.college"
            :clearable="false"
            :custom-error-msg="validationMessages.college"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Universidad:"
            :options="universities"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        v-if="user.profile.companyid == undefined"
        class="col-sm-12 col-md-4 col-lg-4 mt-4 mt-md-2 mt-sm-4"
      >
        <validation-provider
          v-if="user.profile.companyid == undefined"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-drop-down
            v-model="value.company"
            :clearable="false"
            :custom-error-msg="validationMessages.company"
            :disabled="editMode"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Compañía:"
            :options="companies"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div
        :class="
          this.user.profile.companyid != undefined
            ? 'col-sm-12 col-md-4 col-lg-4 mt-4 mt-md-2 mt-sm-4'
            : 'col-sm-12 col-md-6 col-lg-3 mt-4 mt-md-2 mt-sm-4'
        "
      >
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.specialtyType"
            :clearable="false"
            :custom-error-msg="validationMessages.specialtyType"
            :disabled="value.practitionerType == null || editMode"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Especialidad:"
            :options="availableSpecialties"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-2 mt-4 mt-md-2 mt-sm-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="value.startDate"
            class-container="w-100"
            :custom-error-msg="validationMessages.startDate"
            :error="errors[0]"
            label="Fecha Desde:"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-2 mt-4 mt-md-2 mt-sm-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="value.endDate"
            class-container="w-100"
            :custom-error-msg="validationMessages.endDate"
            :error="errors[0]"
            label="Fecha Hasta:"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';

import { mapState } from 'vuex';

import {
  getPractitionerTypes as _getPractitionerTypes,
  getSpecialistSpecialtyTypes as _getSpecialistSpecialtyTypes,
  getUniversities as _getUniversities,
} from '@/modules/shared/code.api.js';

import { getProvidersByAcademicyearId as _getProvidersByAcademicyearId } from '@/modules/shared/provider.api';

export default {
  name: 'SpecialtyInformation',
  components: {
    CustomDropDown,
    CustomDatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: null,
        practitionerType: null,
        practitionerTypeId: null,
        practitionerTypeName: null,
        college: null,
        collegeId: null,
        collegeName: null,
        company: null,
        companyId: null,
        companyName: null,
        specialtyType: null,
        specialtyTypeId: null,
        specialtyTypeName: null,
        startDate: null,
        endDate: null,
        disciplineTypes: [],
        originalPractitionerType: null,
        originalSpecialtyType: null,
      }),
    },
    usedSpecialties: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      practitionerTypes: [],
      disciplineTypes: [],
      universities: [],
      specialties: [],
      companies: [],
      validationMessages: {
        practitionerType: 'Favor seleccionar un tipo practicante o interno.',
        college: 'Favor seleccionar una universidad.',
        specialtyType: 'Favor seleccionar una especialidad.',
        startDate: 'Fecha desde es requerida.',
        endDate: 'Fecha hasta es requerida.',
        company: 'La compañía es requerida.',
      },
      editMode: false,
    };
  },
  computed: {
    ...mapState('$_user', ['user']),
    availableSpecialties() {
      let result = this.specialties.filter((item) => {
        if (this.value.practitionerType == null) return false;

        return !this.usedSpecialties.some((x) => x.id == item.id);
      });

      if (this.editMode) {
        let addExisting = !result.some(
          (x) => x.id == this.value.originalSpecialtyType.id
        );

        if (addExisting) result.push(this.value.originalSpecialtyType);
      }

      return result.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
  },
  watch: {
    'value.practitionerType'(newValue) {
      if (newValue != null) {
        this.value.practitionerTypeId = newValue.id;
        this.value.practitionerTypeName = newValue.name;
      } else {
        this.value.practitionerTypeId = null;
        this.value.practitionerTypeName = null;
      }
    },
    'value.college'(newValue) {
      if (newValue != null) {
        this.value.collegeId = newValue.id;
        this.value.collegeName = newValue.name;
      } else {
        this.value.collegeId = null;
        this.value.collegeName = null;
      }
    },
    'value.specialtyType'(newValue) {
      if (newValue != null) {
        this.value.specialtyTypeId = newValue.id;
        this.value.specialtyTypeName = newValue.name;
      } else {
        this.value.specialtyTypeId = null;
        this.value.specialtyTypeName = null;

        this.disciplineTypes = [];
      }
    },
    'value.company'(newValue) {
      if (newValue != null) {
        this.value.companyId = newValue.id;
        this.value.companyName = newValue.name;
      } else {
        this.value.companyId = null;
        this.value.companyName = null;
      }
    },
  },
  created() {
    _getPractitionerTypes().then((resp) => {
      this.practitionerTypes = resp.data;
    });
    _getSpecialistSpecialtyTypes().then((resp) => {
      this.specialties = resp.data;
    });
    _getUniversities().then((resp) => {
      this.universities = resp.data;
    });
    if (this.user.profile.companyid == undefined) {
      _getProvidersByAcademicyearId(this.currentAcademicYear().id).then(
        (resp) => {
          this.companies = resp.data;
        }
      );
    }
  },
  mounted() {
    if (this.value.practitionerTypeId != null && this.value.specialtyTypeId) {
      this.editMode = true;
    }

    this.value.originalSpecialtyType = this.value.specialtyType;
    this.value.originalPractitionerType = this.value.practitionerType;
  },
};
</script>
